const en = {
    nav: { //头部导航
        navList: [{
                name: "Home",
                url: "/",
            },
            {
                name: "About Us",
                url: "/about",
            },
            {
                name: "Main Product",
                url: "/gpc",
            },
            {
                name: "Business Areas",
                url: "/besinessScope/bulkTrade",
            },
            {
                name: "News Center",
                url: "/news",
            },
            {
                name: "Social Responsibility",
                url: "/socialResponsibility",
            },
            {
                name: "Talent Development",
                url: "/talentDevelopment",
            },
            {
                name: "Supervision And Reporting",
                url: "/supervisionAndReporting",
            },
        ],
        Logo: require("../../assets/img/base/logo20.png"),
        Logo_white: require("../../assets/img/base/logo20_white.png"),
        Language: {
            cn: "中文",
            en: "ENGLISH",
            ru: "РУССКИЙ"
        },
    },
    foot: { //脚注和全屏菜單
        footNav: [{
                title: {
                    name: "About Us",
                    url: "/about",
                },
                list: [{
                        name: "Group Profile",
                        url: "/about",
                        param: "company"
                    },
                    {
                        name: "Development History",
                        url: "/about",
                        param: "history"
                    },
                    {
                        name: "Corporate Culture",
                        url: "/about",
                        param: "culture"
                    },
                    {
                        name: "Honors & Awards",
                        url: "/about",
                        param: "honor"
                    },
                    {
                        name: "Team Highlights",
                        url: "/about",
                        param: "teamStyle"
                    },
                ]
            },
            {
                title: {
                    name: "Main Product",
                    url: "/gpc",
                },
                list: [{
                        name: "Petroleum Coke",
                        url: "/gpc",
                        param: ""
                    },
                    {
                        name: "Calcined Coke",
                        url: "/cpc",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "Business Sectors",
                    url: "/besinessScope/bulkTrade",
                },
                list: [{
                        name: "Bulk Trade",
                        url: "/besinessScope/bulkTrade",
                        param: ""
                    },
                    {
                        name: "Integrated Logistics",
                        url: "/besinessScope/integratedLogistics",
                        param: ""
                    },
                    {
                        name: "Manufacturing",
                        url: "/besinessScope/productionManufacturing",
                        param: ""
                    },
                    {
                        name: "Industry-Finance Coordination",
                        url: "/besinessScope/industryFinanceCollaboration",
                        param: ""
                    },
                    {
                        name: "Labor Export",
                        url: "/besinessScope/exportOfServices",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "News Center",
                    url: "/news",
                },
                list: [{
                        name: "Latest News",
                        url: "/news",
                        param: "tab1"
                    },
                    {
                        name: "Media reports",
                        url: "/news",
                        param: "tab2"
                    },
                    {
                        name: "Corporate Publicity",
                        url: "/news",
                        param: "tab3"
                    },
                ]
            },
            {
                title: {
                    name: "Social Responsibility",
                    url: "/socialResponsibility",
                },
                list: [{
                        name: "Environmental Protection",
                        url: "/socialResponsibility",
                        param: "environmental"
                    },
                    {
                        name: "Scientific And Technological Innovation",
                        url: "/socialResponsibility",
                        param: "science"
                    },
                    {
                        name: "Social Welfare",
                        url: "/socialResponsibility",
                        param: "socialGood"
                    },
                ]
            },
            {
                title: {
                    name: "Talent Development",
                    url: "/talentDevelopment",
                },
                list: [{
                        name: "Talent Development",
                        url: "/talentDevelopment",
                        param: ""
                    },
                    {
                        name: "Talent Recruitment",
                        url: "/talentRecruitment/1",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "Supervision and Reporting",
                    url: "/supervisionAndReporting",
                },
                list: [{
                    name: "Supervision and Reporting",
                    url: "/supervisionAndReporting",
                    param: ""
                }]
            },
        ],
        Address: "Address: 13/F, China Minmetals Building, No. 15, Anhuili Fourth District, Chaoyang District, Beijing, China",
        Phone: "Tel: +86 10-84831159  &nbsp;&nbsp;  Domestic Trade:  +86 10-84833454  &nbsp;&nbsp;  International Trade: +86 10-84832433",
        tel:"Business Cooperation: +86 17813617961 &nbsp;&nbsp; Executive Office: +86 17813617885",
        Email: "Email: Gaoxin@gaoxincarbon.com",
        RecruitTel: "Recruitment Hotline: 17813617991",
        RecruitEmail: "Resume Email: hr@dqc.group",
        contactUs: "Follow Us",
        copyright: "DQ CARBON GROUP",
    },
    sidebar: {
        Message: "Leave a message online",
    },
    dialogContact: { //联系我们弹框
        TelephoneCounseling: "电话咨询",
        DomesticTradePhone: "内贸",
        ForeignTradePhone: "外贸",
        HRphone: "总机"
    },
    messageBoard: { //在线留言弹框
        OnlineMessage: "Leave a message online",
        BusinessType: "Business Type",
        SelectBusinessType: "Select Business Type",
        name: "name",
        phone: "phone",
        email: "email",
        message: "message",
        SubmitMessage: "submit",
        rules: {
            SelectBusinessType: "Select Business Type",
            EnterName: "Please enter your name",
            NameLength: "Between 2 and 20 characters in length",
            ContactNumber: "Please enter contact number",
            PhoneLength: "Please enter the correct mobile number",
            EmailAddress: "Please enter email address",
            CorrectEmailAddress: "Please enter the correct email address",
            messageContent: "Please enter the message ",
        },
        SubmitSuccessfully: "Successful submission"
    },
    home: {
        banner: {
            businessScope: [{
                    title: "Bulk Trade",
                    icon: require("../../assets/img/home/trade.png"),
                    des: "Group Core Business Modules",
                    businessSlide: `<li>Energy</li>
                        <li>Industrial Raw Materials</li>
                        <li>Metals/Minerals</li>
                        <li>Petrochemical Products</li>
                        <li>Agricultural Products</li>
                        <li>Electromechanical Instrument</li>
                        <li>Lithium batteries and their upstream and downstream products</li>`,
                    pic: require("../../assets/img/base/trade.png"),
                    src: '/besinessScope/bulkTrade'
                },
                {
                    title: "Integrated Logistics",
                    icon: require("../../assets/img/home/logistics.png"),
                    des: "Global Logistics Network",
                    businessSlide: `<li>Warehousing And Logistics</li>
                        <li>Cross-Border Logistics</li>
                        <li>Freight Network</li>`,
                    pic: require("../../assets/img/base/logistics.png"),
                    src: '/besinessScope/integratedLogistics'
                },
                {
                    title: "Manufacturing",
                    icon: require("../../assets/img/home/manufacturing.png"),
                    des: "Industrial Chain Upgrading",
                    businessSlide: `<li>Fushun Longteng Factory</li>
                        <li>Aluminum Products Processing Plant</li>`,
                    pic: require("../../assets/img/base/manufacturing.png"),
                    src: '/besinessScope/productionManufacturing'
                },
                {
                    title: "Industry-Finance Coordination",
                    icon: require("../../assets/img/home/finance.png"),
                    des: "Asset Value Development",
                    businessSlide: `<li>Global Layout</li>
                        <li>Procurement And Distribution</li>
                        <li>Protection And Factoring</li>
                        <li>Industrial Investment</li>`,
                    pic: require("../../assets/img/base/finance.png"),
                    src: '/besinessScope/industryFinanceCollaboration'
                },
                {
                    title: "Labor Export",
                    icon: require("../../assets/img/home/services.png"),
                    des: "Human Resources",
                    businessSlide: `<li>Enterprise Advantage</li>`,
                    pic: require("../../assets/img/base/services.png"),
                    src: '/besinessScope/exportOfServices'
                }
            ],
            year20: "20th Anniversary Special Report"
        },
        company: {
            headlineTitle: "Company Introduction",
            headlineP: "COMPANY INTRODUCTION",
            map: {
                Canada: "Canada",
                USA: "USA",
                Colombia: "Colombia",
                Brazil: "Brazil",
                Chile: "Chile",
                Argentina: "Argentina",
                Germany: "Germany",
                Romania: "Romania",
                Turkey: "Turkey",
                Egypt: "Egypt",
                Saudi_Arabia: "Saudi_Arabia",
                Kazakhstan: "Kazakhstan",
                Turkmenistan: "Turkmenistan",
                Dubai: "Dubai",
                India: "India",
                Russia: "Russia",
                China: "China",
                Taiwan: "Taiwan Province of China",
                Malaysia: "Malaysia",
                Korea: "Korea",
                Japan: "Japan",
                Philippines: "Philippines",
                Indonesia: "Indonesia",
                Sydney: "Sydney"
            },
            companyName: "DQ CARBON GROUP",
            nameTag: "DQ CARBON GROUP",
            companyNumber: [{
                    detail: "Establishment of the enterprise"
                },
                {
                    detail: "Domestic and foreign branches"
                },
                {
                    detail: "Countries involved in the business"
                },
                {
                    detail: "Corporate employees"
                },
            ],
            more: "MORE"
        },
        businessLayout: {
            headlineTitle: "Business Iayout",
            headlineP: "BUSINESS LAYOUT",
        },
        product: {
            headlineTitle: "Main Products",
            headlineP: "MAIN PRODUCTS",
            res: [{
                    title: "Petroleum Coke",
                    titleEn: "GPC",
                    des: "The company mainly cooperates with refineries affiliated with Sinopec, PetroChina and CNOOC, as well as local refineries in Shandong, Northeast China, Northwest China, Henan, Hebei and Jiangsu, and large overseas petrochemical enterprises and traders. The  company has established long-term strategic partnerships with major domestic and overseas aluminum plants, steel mills, silicon metal plants, and glass manufacturers.",
                    pic: require("../../assets/img/home/gpc.png"),
                    src: "/gpc"
                },
                {
                    title: "Calcined Coke",
                    titleEn: "CPC",
                    des: `Our company established a calcined coke processing plant in Huludao, Liaoning in 2018. The commissioned processing form can reach 200,000 tons and 6,000 tons per month of low-sulfur calcined coke for graphite electrodes. The company employs calcined coke processing industry experts and has a professional technical team, mainly for Jinxi Daqing Fushun petroleum coke calcination and screening business can be customized according to customer needs, and the quality of incoming processing services is guaranteed. In terms of product quality and price, logistics and warehousing product inspection, and rapid settlement, we can optimize the procurement plan for our customers to ensure that the product quality is qualified, the price is reasonable, and the delivery is timely. Reduce costs for our customers, provide satisfactory service, and create greater value.`,
                    pic: require("../../assets/img/home/cpc.png"),
                    src: "/cpc"
                },
            ],
            button: "Learn More"
        },
        news: {
            headlineTitle: "News Information",
            headlineP: "NEWS INFORMATION",
        },
        partner: {
            headlineTitle: "Cooperative Enterprise",
            headlineP: "COOPERATIVE ENTERPRISE",

        }
    },
    about: {
        banner: {
            bannerTitle: "About Us",
            bannerP: "Aspire Resources - Create Value",
        },
        company: {
            headlineTitle: "Group Profile",
            headlineP: "GROUP PROFILE",
        },
        messageFromChairman: {
            title: "The Chairman'S Message",
        },
        history: {
            headlineTitle: "Development History",
            headlineP: "DEVELOPMENT HISTORY",
        },
        culture: {
            headlineTitle: "Corporate Culture",
            headlineP: "CORPORATE CULTURE",
            section: [{
                    title: "Development perspective",
                    des: `<p>Rule of law and rule of virtue in enterprises</p><p>Frugality and frugality in running enterprises, integrity and love for enterprises</p><p>Talents strengthen enterprises, technology promotes enterprises</p>`
                },
                {
                    title: "Market perspective",
                    des: `<p>Make every effort to ensure quality control and build an outstanding brand in the industry</p><p>The success of our customers is our success</p><p>The value of our customers is also our value</p>`
                },
                {
                    title: "Talent perspective",
                    des: `<p>Advocating knowledge and putting people first</p><p>Respect and care for talents</p><p>Cultivate and reuse talents</p>`
                },
                {
                    title: "Efficiency perspective",
                    des: `<p>Take one step ahead and lead the way</p>`
                },
                {
                    title: "Struggle viewpoint",
                    des: `<p>A great cause is achieved by putting it together</p><p>Made and fought for</p>`
                },
                {
                    title: "Growth perspective",
                    des: `<p>Self discipline is enough to please others, and tolerance is enough to treat others</p><p>Light wealth is enough to gather people, and one's body is the first to lead others</p>`
                }
            ]
        },
        honor: {
            headlineTitle: "Honors & Awards",
            headlineP: "HONORS & AWARDS",
        },
        teamStyle: {
            headlineTitle: "Team Highlights",
            headlineP: "TEAM HIGHLIGHTS",
        }
    },
    mainBusiness: {
        gpc: {
            header: {
                typeTitle: "Main Products",
                title: "Petroleum Coke",
                enTitle: "GPC",
                des: `The company mainly cooperates with refineries affiliated with Sinopec, PetroChina and CNOOC, as well as local refineries in Shandong, Northeast China, Northwest China, Henan, Hebei and Jiangsu, and large overseas petrochemical enterprises and traders. The  company has established long-term strategic partnerships with major domestic and overseas aluminum plants, steel mills, silicon metal plants, and glass manufacturers.`,
            },
            parameters: {
                title: "Typical Value",
                tabs: {
                    internal: "Domestic",
                    foreign: "Overseas",
                },
                parameterRow: [{
                        pic: require("../../assets/img/mainBusiness/sy.png"),
                        lists: [{
                                value: "＜0.5",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜0.35",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜100",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜200",
                                name: "Silicon content(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/sh.png"),
                        lists: [{
                                value: "＜2.2",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜0.5",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜150",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜100",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜200",
                                name: "Silicon content(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/nooc.png"),
                        lists: [{
                                value: "＜0.5",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜0",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜250",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜200",
                                name: "Silicon content(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/dl.png"),
                        lists: [{
                                value: "＜4.5",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜350",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜300",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜200",
                                name: "Silicon content(%)"
                            },
                        ]
                    }
                ],
                foreignParameterRow: [{
                        title: "Middle East",
                        pic: require("../../assets/img/mainBusiness/zhongdong.png"),
                        lists: [{
                                value: "＜3.3",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜200",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜200",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜100",
                                name: "Silicon content(%)"
                            },
                        ]
                    },
                    {
                        title: "Indonesia",
                        pic: require("../../assets/img/mainBusiness/yingni.png"),
                        lists: [{
                                value: "＜0.50",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜14.5",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜120",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜150",
                                name: "Silicon content(%)"
                            },
                        ]
                    },
                    {
                        title: "America",
                        pic: require("../../assets/img/mainBusiness/meiguo.png"),
                        lists: [{
                                value: "＜4.5",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜12",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜450",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜150",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜180",
                                name: "Silicon content(%)"
                            },
                        ]
                    },
                    {
                        title: "Europe",
                        pic: require("../../assets/img/mainBusiness/ouzhou.png"),
                        lists: [{
                                value: "＜1.5",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜200",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜150",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜150",
                                name: "Silicon content(%)"
                            },
                        ]
                    },
                    {
                        title: "South America",
                        pic: require("../../assets/img/mainBusiness/nanmei.png"),
                        lists: [{
                                value: "＜0.7",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜180",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜80",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜80",
                                name: "Silicon content(%)"
                            },
                        ]
                    },
                    {
                        title: "The Commonwealth of Independent States",
                        pic: require("../../assets/img/mainBusiness/dulianti.png"),
                        lists: [{
                                value: "＜1.8",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "＜10",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜200",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "＜150",
                                name: "Iron content(%)"
                            },
                            {
                                value: "＜150",
                                name: "Silicon content(%)"
                            },
                        ]
                    }
                ],
            },
            petroleumBases: {
                headline2: {
                    title: "China’s Four Major Petroleum Coke Production Bases",
                    enTitle: "China’s Four Major Petroleum Coke Production Bases"
                },
                lists: [{
                        pic: require("../../assets/img/mainBusiness/db.png"),
                        title: "Northeast China Base",
                        des: "Make full use of the advantages of Northeast China's resources, optimize and consolidate the construction and layout plan of the warehousing and mixed logistics base, and carry out differentiated operations."
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/hd.png"),
                        title: "East China Base",
                        des: "Base personnel implement a dual professional and localized management model to improve services and improve the level of professional management."
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/hn.png"),
                        title: "South China Base",
                        des: "Based on the advantages of the South China market and industrial layout, promote the extension of petroleum coke products to the downstream industrial chain and improve the comprehensive business operation capabilities."
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/xb.png"),
                        title: "Northwest China Base",
                        des: "Improve the linkage mechanism of the integration of procurement, sales and logistics management, and enhance the ability to actively cooperate and respond quickly to the market."
                    }
                ]
            },
            storageBase: {
                headline2: {
                    title: "Storage base",
                    enTitle: "Storage base"
                },
                des: `The company mainly cooperates with refineries affiliated with Sinopec, PetroChina and CNOOC, as well as local refineries in Shandong, Northeast China, Northwest China, Henan, Hebei and Jiangsu, and large overseas petrochemical enterprises and traders. The  company has established long-term strategic partnerships with major domestic and overseas aluminum plants, steel mills, silicon metal plants, and glass manufacturers.`
            },
            recommend: {
                headline2: {
                    title: "Related Products",
                    enTitle: "Relevant recommendation"
                }
            }
        },
        cpc: {
            header: {
                typeTitle: "Main Products",
                title: "Calcined Coke",
                enTitle: "CPC",
                des: `Our company established a calcined coke processing plant in Huludao, Liaoning in 2018. The commissioned processing form can reach 200,000 tons and 6,000 tons per month of low-sulfur calcined coke for graphite electrodes. The company employs calcined coke processing industry experts and has a professional technical team, mainly for Jinxi Daqing Fushun petroleum coke calcination and screening business can be customized according to customer needs, and the quality of incoming processing services is guaranteed. In terms of product quality and price, logistics and warehousing product inspection, and rapid settlement, we can optimize the procurement plan for our customers to ensure that the product quality is qualified, the price is reasonable, and the delivery is timely. Reduce costs for our customers, provide satisfactory service, and create greater value.`,
            },
            parameters: {
                titleM: "Medium Sulfur Coke",
                parameterM: [{
                        pic: require("../../assets/img/mainBusiness/zbh.png"),
                        name: "Index goods",
                        lists: [{
                                value: "≤3",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "≤1.5",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "≤500",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "≥2.05",
                                name: "TRUE DENSITY(%)"
                            },
                            {
                                value: "≤0.5",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜500",
                                name: "SPECIFIC RESISTANCE(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/puhuo.png"),
                        name: "General goods",
                        lists: [{
                                value: "≤3.5",
                                name: "Sulfur content(%)"
                            },
                            {
                                value: "≤1.5",
                                name: "Volatile content(%)"
                            },
                            {
                                value: "≥600",
                                name: "Vanadium content(%)"
                            },
                            {
                                value: "≥2.05",
                                name: "TRUE DENSITY(%)"
                            },
                            {
                                value: "≤0.5",
                                name: "Ash content(%)"
                            },
                            {
                                value: "＜550",
                                name: "SPECIFIC RESISTANCE(%)"
                            },
                        ]
                    },
                ],
                titleL: "Low-sulfur coke",
                parameterL: [{
                    pic: require("../../assets/img/mainBusiness/fsgc.png"),
                    name: "Fushun Factory",
                    lists: [{
                            value: "≤0.5",
                            name: "Sulfur content(%)"
                        },
                        {
                            value: "≤0.5",
                            name: "Volatile content(%)"
                        },
                        {
                            value: "0.5",
                            name: "水分(%)"
                        },
                        {
                            value: "≥2.08",
                            name: "TRUE DENSITY(%)"
                        },
                        {
                            value: "≤0.5",
                            name: "Ash content(%)"
                        },
                        {
                            value: "350~450",
                            name: "SPECIFIC RESISTANCE(%)"
                        },
                    ],
                    url: '/besinessScope/productionManufacturing'
                }, ],
            },
            recommend: {
                headline2: {
                    title: "Relevant recommendation",
                    enTitle: "Relevant recommendation"
                }
            }
        }
    },
    bulkTrade: {
        banner: {
            bannerTitle: "Bulk Trade",
            bannerP: "Bulk Trade",
        },
        headlineTitle: "Bulk Trade",
        headlineP: "BULK TRADE",
        mainBusiness: 'Main Product',

    },
    bulkTradeDetail: {
        home: "Home",
        lists: "Bulk Trade",
        share: "Share",
        copyAddress: 'Copy address',
        productIntroduction: "Product Introduction",
        factoryIntroduction: 'Operating site',
        relevantRecommendation: 'Related Products'
    },
    integratedLogistics: {
        banner: {
            bannerTitle: "Logistics Services",
            bannerP: "Logistics Services",
        },
        logisticsService: {
            headlineTitle: "Logistics Services",
            headlineP: "LOGISTICS SERVICE",
            lists: [{
                    title: "Road transport",
                    des: `Based on years of operational accumulation, the company has integrated over 8000 cooperative vehicle resources, covering bulk cargo, engineering vehicles, spare parts, dangerous goods and other goods. Based on rich experience in transportation capacity management and aiming for high-quality customer service experience, we provide domestic road transportation services to our customers.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service1.png")
                },
                {
                    title: "Rail transportation",
                    des: `We have a highly qualified and experienced professional team in railway services, specializing in organizing the transportation of bulk goods, engineering equipment, and large cargo. We are able to efficiently handle various complex transportation needs and our business covers various regions in China, as well as countries and regions such the five Central Asian countries, to safeguard the shipment of customers' goods.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service2.png")
                },
                {
                    title: "Sea freight",
                    des: `Based on long-term stable cooperation with shipping companies and ports, we develop comprehensive transportation plans according to customer requirements and provide one-stop bulk shipping services such as chartering and booking, port consolidation, loading supervision, and cargo tracking.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service3.png")
                },
                {
                    title: "Multimodal transport",
                    des: `Focus on customer needs, integrate various resources such as roads, railways, and waterways to provide customers with door-to-door multimodal transport solutions, give full play to the advantages and combined efficiency of various modes of transportation, and streamline transportation links for customers. Save freight costs and improve economic benefits.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service4.png")
                },
                {
                    title: "Cross-border logistics",
                    des: `In response to the call of the national “One Belt and One Road” initiative, accelerate the internationalization of business, face the different needs of customers, provide integrated services for international transportation, overseas customs clearance, and cross-border RMB settlement, open up pain points in the multinational supply chain, and can undertake large-scale long-term association business.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service5.png")
                },
                {
                    title: "Liquefied gas tanker transportation",
                    des: `The company has a professional transportation management team that is familiar with the physical and chemical properties of LPG and the safety transportation standards for dangerous goods. We provide customized LPG transportation solutions for customers, and all vehicles are equipped with GPS satellite positioning systems and emergency braking systems to achieve full process visual monitoring and rapid response, ensuring comprehensive transportation safety.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service6.png")
                },
            ]
        },
        loremIpsumDolorSit: {
            headlineTitle: "Purchasing Agency Service",
            headlineP: "PURCHASING AGENCY SERVICE",
            des: "The company has established strategic import and export bases in important domestic ports such as Panjin, Rizhao, Weifang, Lianyungang, Fangcheng, Qinzhou, as well as South Korea; it has established cargo warehouses and processing bases in Xinjiang, Qinghai, Gansu, Ningxia, Shandong, Henan, Chongqing, Liaoning and other domestic provinces and cities.",
            map: require('../../assets/img/businessScope/integratedLogistics/map-en.png'),
            lists: [{
                    title: "Logistics processing",
                    des: `According to the nature of the goods and customer needs, value-added services such as screening, blending, and filling can be provided to meet the diverse needs of customers.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/wljg.png"),
                    icon: require("../../assets/img/businessScope/integratedLogistics/wljg_icon.png"),
                },
                {
                    title: "Purchasing Agency Service",
                    des: `We have built a platform for exhibition and procurement of bulk goods and commodities such as petroleum equipment, construction machinery, vehicle parts, electronic products and ores, combined with door-to-door transportation services to provide customers with a full range of procurement agency services for customers.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/cgdl.png"),
                    icon: require("../../assets/img/businessScope/integratedLogistics/cgdl_icon.png"),
                },
            ]
        },
        networkFreight: {
            headlineTitle: "Freight Network",
            headlineP: "NETWORK FREIGHT",
            picUrl: require("../../assets/img/businessScope/integratedLogistics/wlhy-en.jpg"),
            lists: [{
                    title: "Hao Yunda Platform",
                    des: "Self-built group logistics service trading platform, process management, electronic ledger, support system docking and coordination, and provide one-stop transportation services.",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network1.png"),
                },
                {
                    title: "Corporate empowerment",
                    des: "It has its own R&D team to assist enterprises in promoting digital transformation and reduce costs and increase efficiency for enterprise informationization.",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network2.png"),
                },
                {
                    title: "Value-Added Services",
                    des: "With land transport bulk bulk cargo transportation business as the core, we will build an ecological industrial chain of shippers, drivers, platforms, insurance, finance, and after-vehicle services.",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network3.png"),
                },

            ]
        },
        projectCase: {
            headlineTitle: "Project Case",
            headlineP: "PROJECT CASE",
            lists: [{
                    title: "Engineering vehicle cross-border highway project",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case1.png"),
                },
                {
                    title: "Road transport of over-restricted goods",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case2.png"),
                },
                {
                    title: "Aluminum products shipping container LCL",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case3.png"),
                },
                {
                    title: "China-EU train rail transportation",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case4.png"),
                },
                {
                    title: "Vehicle and accessories container project",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case5.png"),
                },
                {
                    title: "Commodity shipping project",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case6.png"),
                },
            ]
        }
    },
    productionManufacturing: {
        banner: {
            bannerTitle: "Production Manufacturing",
            bannerP: "Production Manufacturing",
        },
        table: {
            fushun: "Fushun Longteng Factory",
            lv: "Aluminum products processing plant"
        },
        FS: {
            factory: {
                headlineTitle: "Fushun Longteng Factory",
                headlineP: "FUSHUN LONGTENG FACTORY",
                des: `DQ CARBON GROUP established a wholly-owned subsidiary-Fushun Longteng New Materials Co., Ltd. in April 2022. It is mainly engaged in the research and development, production and sales of new materials and new energy technology products. It is a key investment attraction enterprise in Liaoning Province and a leading backbone enterprise in the new energy industry in Fushun City.`,
                factoryBox: {
                    title: "FUSHUN LONGTENG FACTORY",
                    smallTitle: "Fushun Longteng Factory",
                    des: `The project is located in Fushun High tech Industrial Development Zone, covering an area of about 192 acres with a total design investment of 1.71 billion yuan. It mainly produces lithium battery artificial graphite negative electrode materials, carbon and other new materials, new energy products and related technology research and sales. The products have been sold well in various parts of China and exported to multiple countries and regions.`,
                    link: 'Fushun Longteng Factory：https://www.fsltxcl.cn/'
                }
            },
            manufacturingStrength: {
                headlineTitle: "Manufacturing Strength",
                headlineP: "MANUFACTURING STRENGTH",
                lists: [{
                        title: "Negative electrode workshop",
                        des: `The negative electrode workshop production line integrates multiple processes such as crushing, drying, and crushing of negative electrode materials, and achieves efficient conversion from raw materials to finished products through highly automated equipment and processes.`,
                        des2: `Annual production capacity: drying production line 150000 tons, crushing production line 100000 tons.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl1.png")
                    },
                    {
                        title: "Calcination workshop",
                        des: `The calcination workshop is mainly composed of raw material pretreatment equipment, calcination furnace equipment, cooling water equipment, desulfurization tower equipment, waste heat boiler equipment and other devices.`,
                        des2: `Annual production capacity: 60000 tons of calcination production line.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl2.png")
                    },
                    {
                        title: "Granulation workshop",
                        des: `The granulation workshop is a specialized production area for granulation of new energy materials, and its products are widely used in various fields of the new energy industry.`,
                        des2: `Plan, construct, and put into operation an annual production line of 80000 tons for granulation and pre carbonization.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl3.png")
                    },
                ]
            },
            mainProduct: {
                headlineTitle: "Main Products",
                headlineP: "MAIN PRODUCTS",
                lists: [{
                        title: "Low sulfur calcined coke",
                        des: `High-quality low-sulfur petroleum coke is selected for production, and after crushing and calciner treatment, it can be used as a lithium battery negative electrode and a high-quality graphite electrode raw material. Products are used in the lithium battery negative electrode industry and the high-power, ultra-high-power graphite electrode carbon industry, and can be customized according to customer needs.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main1.png")
                    },
                    {
                        title: "Lithium battery negative electrode crushing precursor",
                        des: `The crushing precursor of the new energy lithium battery negative electrode is produced from high-quality petroleum coke, needle coke or calcined coke in the lithium battery negative electrode industry, and the product can be customized according to customer needs.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main2.png")
                    },
                    {
                        title: "Calcined coke artificial graphite anode material",
                        des: `High-quality raw materials are selected and processed through multiple processes. The product has small expansion, good processing performance, high capacity, and outstanding comprehensive price ratio. It is suitable for energy storage and high-capacity 3C batteries.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main3.png")
                    },
                    {
                        title: "Artificial graphite anode material",
                        des: `High-quality raw materials are selected and finely processed by multiple heat treatment processes such as granulation and pre-carbonization. Excellent high temperature cycle performance and magnification, good capacity and processing performance, suitable for electric vehicles and other power negative electrodes.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main4.png")
                    },
                    {
                        title: "Needle-shaped coke artificial graphite anode material",
                        des: `Using high-quality needle coke as raw material, after crushing, granulation, graphitization and post-process treatment, the product has good capacity, cycle performance and magnification performance, and is suitable for use in various fields of high-end negative electrodes.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main5.png")
                    },
                ]
            },
            qualityAssurance: {
                headlineTitle: "Quality Assurance",
                headlineP: "QUALITY ASSURANCE",
                lists: [{
                        title: "Bettersize2600 laser particle size analyzer",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/baitejiguan.jpg")
                    },
                    {
                        title: "Powder resistivity tester",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/fengmodianzu.jpg")
                    },
                    {
                        title: "ARL PERFORM’X  X-ray fluorescence spectrometer",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/guangpuyi.jpg")
                    },
                    {
                        title: "Malvern Mastersizer3000 laser particle size analyzer",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/jiguangliduyi.jpg")
                    },
                    {
                        title: "True density meter",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/zhengmiduyi.jpg")
                    },
                    {
                        title: "Vibrating density meter",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/zhengshimiduyi.jpg")
                    },
                ]
            },
            honorAndAualification: {
                headlineTitle: "Technical Patents",
                headlineP: "TECHNICAL PATENTS",
                list: [
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/1.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/2.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/3.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/4.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/5.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/6.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/7.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/8.jpg") },
                ]
            },
            schoolEnterpriseCooperation: {
                headlineTitle: "School-Enterprise Cooperation",
                headlineP: "SCHOOL-ENTERPRISE COOPERATION",
                des: "<p>At the same time, it has established “industry-university-research” school-enterprise cooperation with Liaoning University of Petroleum and Chemical Technology, Northeastern University and many other colleges and universities.</p>",
                tip: "More institutions are being updated..."
            },
        },
        AL: {
            factory: {
                headlineTitle: "Aluminum Products Processing Plant",
                headlineP: "ALUMINIUM PRODUCT PROCESSING PLANT",
                des: `The aluminum products processing plant is a wholly-owned subsidiary of DQ CARBON GROUP. It is a factory that produces various types of aluminum coils and aluminum plates. It provides products and services for a wide range of industries, including aerospace, automobiles, housing and construction, transportation, packaging and daily necessities.`,
                factoryBox: {
                    title: "ALUMINIUM PRODUCT PROCESSING PLANT",
                    smallTitle: "Aluminum products processing plant",
                    des: `It can produce and sell all kinds of aluminum coils, aluminum foil, and aluminum plates. It can be widely used in furniture, kitchenware and other fields. The products have been exported to more than 30 countries, Brazil, Mexico, the United Arab Emirates, Vietnam, Thailand, and the Philippines.`
                }
            },
            manufacturingStrength: {
                headlineTitle: "Manufacturing Strength",
                headlineP: "MANUFACTURING STRENGTH",
                lists: [{
                        title: "Product customization",
                        des: "Show us samples or drawings and we will bring you the perfect product.",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service1.png")
                    },
                    {
                        title: "Fees and services",
                        des: "Integrating production and sales, we have rolling and deep processing workshops and a professional foreign trade team. You can not only enjoy the manufacturer's price, but also professional foreign trade services.",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service2.png")
                    },
                    {
                        title: "Response speed",
                        des: "Your email, inquiry and question will be replied within 2 hours. Complete all work in a short time, and samples and bulk orders will be delivered on time with high standards.",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service3.png")
                    },
                    {
                        title: "Product quality",
                        des: "Strict quality control system and advanced inspection equipment.",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service4.png")
                    },
                ]
            },
            mainProduct: {
                headlineTitle: "Main Products",
                headlineP: "MAIN PRODUCTS",
                lists: [{
                        title: "Aluminum plate",
                        des: "<p>Thickness range: 0.2-20mm</p><p>Width range: 50-2200 mm</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvban.png")
                    },
                    {
                        title: "Aluminum coil",
                        des: "<p>Thickness range: 0.2-5mm0.2-5mm</p><p>Width range: 50-1600mm</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvjuan.png")
                    },
                    {
                        title: "Aluminum discs",
                        des: "<p>Thickness range: 0.5-5mm</p><p>Width range: 150-1500mm</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvyuanpian.png")
                    },
                    {
                        title: "Aluminum foil",
                        des: "<p>Thickness range: 0.01-0.2mm</p><p>Width range: 50-2200mm</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvbo.png")
                    },
                    {
                        title: "Aluminum rod",
                        des: "<p>Thickness range: 1-3000mm</p><p>Width range: 50-2200mm</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvbang.png")
                    },
                    {
                        title: "Aluminum ingot",
                        des: "<p>Thickness range: 760*185*90mm</p><p>Weight: About 20-25 kg</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvding.png")
                    },
                ]
            },
            qualityAssurance: {
                headlineTitle: "Quality Assurance",
                headlineP: "QUALITY ASSURANCE",
                lists: [{
                        title: "Bending correction equipment",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz1.png")
                    },
                    {
                        title: "Hot rolling mill roll",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz2.png")
                    },
                    {
                        title: "Hot rolling mill unit",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz3.png")
                    },
                    {
                        title: "Warehouse inventory",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz4.png")
                    },

                ]
            },
        },

    },
    industryFinanceCollaboration: {
        banner: {
            bannerTitle: "Industry Finance Collaboration",
            bannerP: "Industry Finance Collaboration",
        },
        globalLayout: {
            headlineTitle: "Purchasing Agency Service",
            headlineP: "PURCHASING AGENCY SERVICE",
            des: `DQ CARBON GROUP started in 2007 and has set up offices in South Korea, Japan, Indonesia, Dubai and many other places one after another. After years of deep cultivation and development, the company's cross-border business has now covered six major fields: energy and chemical raw materials and their products, machinery and equipment and industrial equipment, new energy materials and their lithium battery extension products, metal minerals, agrochemicals, and used car exports.`,
            map: require("../../assets/img/businessScope/industryFinanceCollaboration/map_en.png"),
        },
        generationMiningAndGenerationPin: {
            headlineTitle: "Generation Mining And Generation Pin",
            headlineP: "GENERATION MINING AND GENERATION PIN",
            enterpriseAdvantage: {
                title: "Enterprise advantage",
                titleEn: "ENTERPRISE ADVANTAGE",
                des: "<p>Chinese/cross-border</p><p>Import (on behalf of mining)</p><p>Export (consignment)</p>",
                btn: "Contact Us"
            },
            lists: [{
                    title: "Sea Freight",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/haiyun.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/haiyun.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/haiyun.png"),
                },
                {
                    title: "Freight Forwarder",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/huodai.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/huodai.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/huodai.png"),
                },
                {
                    title: "Settlement",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/jiesuan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/jiesuan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/jiesuan.png"),
                },
                {
                    title: "Port",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/gangkou.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/gangkou.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/gangkou.png"),
                },
                {
                    title: "Train",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/banlie.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/banlie.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/banlie.png"),
                },
                {
                    title: "Overseas Warehouse",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/haiwaicang.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/haiwaicang.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/haiwaicang.png"),
                },
                {
                    title: "Inspection",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/jianyan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/jianyan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/jianyan.png"),
                },
                {
                    title: "Customs Declaration",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/baoguan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/baoguan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/baoguan.png"),
                },
            ]
        },
        protectionAndFactoring: {
            headlineTitle: "Protection And Factoring",
            headlineP: "PROTECTION AND FACTORING",
            des1: `DQ CARBON GROUP was awarded the AAA-level customer of China Export Credit Insurance Company (hereinafter referred to as “China Credit Insurance”) in 2023. It is the first private enterprise in Heilongjiang Province to receive this award.，
            At the same time, it is also the first private enterprise in Heilongjiang Province to be approved for China Credit Insurance domestic trade credit insurance.`,
            des2: `The company provides one-stop procurement, transportation, and sales supply chain services throughout the process to ensure the smooth flow of international goods, information funds, and bills, and to ensure that cost-effective goods are provided according to customer requirements. It has professional channels for the procurement and sales of bulk commodities such as petroleum equipment, engineering machinery, vehicle accessories, electronic products, and ore. Combined with door-to-door transportation services, it can provide customers with a one-stop procurement and sales platform.`
        },
        industrialInvestment: {
            headlineTitle: "Industrial Investment",
            headlineP: "INDUSTRIAL INVESTMENT",
            des: "The company will continue to adhere to market-oriented, customer-centric, innovation-driven, and create greater value for investors, partners and society.",
            lists: [{
                    title: "Contact Us",
                    des: `The company's investment focuses on the main business of petroleum coke trade and the production of lithium battery anode materials (lithium battery anode material manufacturing, lithium battery recycling), and the integration of mergers and acquisitions in the upstream and downstream energy fields to improve the synergy and competitiveness of the industrial chain, forming a complete energy cycle system.`,
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/lidian.png"),
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/lidian_icon.png"),
                },
                {
                    title: "Hydrogen Energy Business",
                    des: `The company also pays attention to exploring investment opportunities in the field of new energy. It has cooperated with well-known scientific research institutions and universities at home and abroad to carry out research and experiments on hydrogen energy production technology, and has made a series of breakthroughs and innovations. In the next few years, the company plans to acquire, acquire and incubate hydrogen energy production equipment companies with independent intellectual property rights to contribute to energy transformation and low-carbon development.`,
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/qingnengyuan.png"),
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/qingnengyuan_icon.png"),
                },
            ]

        }
    },
    exportOfServices: {
        banner: {
            bannerTitle: "Export Of Services",
            bannerP: "Export Of Services",
        },
        headlineTitle: "Export Of Services",
        headlineP: "EXPORT OF SERVICES",
        des1: `DQ CARBON GROUP aims to provide one-stop human resource services to global enterprises, build a strong human resource service guarantee system, and create a highly dynamic, agile, and sustainable talent supply chain.`,
        enterpriseAdvantage: {
            title: "Enterprise advantage",
            titleEn: "ENTERPRISE ADVANTAGE",
            des: `Relying on the practical experience accumulated in the past 20 years, in-depth research on the internal and external human resource demand and supply analysis of the enterprise, combined with the current situation and strategic needs of the enterprise's human resource management, design and plan the entire human resource system and structure of the enterprise. At the same time, based on the rise of the digital age, Daqing Gaoxin's human resource planning will focus on researching the service upgrading of digital labor and information technology, and provide in-depth services and support to major employment enterprises.`
        },
        des2: `At present, the company has served more than 20 domestic and foreign enterprises, covering eight categories of refined and comprehensive one-stop services such as human resource planning, salary performance design, incentive mechanism, organizational planning, process system, job system, and talent training. A professional and high-quality talent pool has been established, including more than ten different industries such as petrochemical, electrical instrumentation, machinery, semiconductor, new energy lithium battery, bulk trade, comprehensive functions, technicians, and logistics support.`,
        lists: [{
                title: "20+",
                des: "Serving more than 20 domestic and foreign cooperative enterprises"
            },
            {
                title: "8+",
                des: "Eight categories of refined one-stop service for all parties"
            },
            {
                title: "15+",
                des: "Eight categories of refined one-stop service for all parties"
            },
        ]

    },
    news: {
        banner: {
            bannerTitle: "News Information",
            bannerP: "News Information",
        },
        latestNews: {
            headlineTitle: "Latest News",
            headlineP: "LATEST NEWS",
        },
        mediaReport: {
            headlineTitle: "Media Report",
            headlineP: "MEDIA REPORT",
        },
        enterprisePublicity: {
            headlineTitle: "Enterprise Publicity",
            headlineP: "ENTERPRISE PUBLICITY",
        },
        parameter: {
            read: "Read the full article"
        }
    },
    newsDetail: {
        home: "Home",
        lists: "News Information",
        time: "Time：",
        edit: "Editor：DQ CARBON GROUP",
        share: "Share",
        pre: "Previous：",
        next: "Next："
    },
    socialResponsibility: {
        banner: {
            bannerTitle: "Social Responsibility",
            bannerP: "Social Responsibility",
        },
        environmentalProtection: {
            headlineTitle: "Environmental Protection",
            headlineP: "ENVIRONMENTAL PROTECTION",
            des: {
                text1: `The company deeply practices the concept of green development, continues to pay attention to environmental protection, renewable energy use, energy conservation and emission reduction, and resource recycling in enterprises and supply chains, advocates a “green circular economy”, promotes energy conservation and emission reduction, and takes practical actions to fulfill green commitments and help achieve the goal of “double carbon”.`,
                text2: `The company's Fushun plant is planned in accordance with the norms of the local government not to be eliminated within 15 years, and adopts the environmentally friendly design of advanced German ultra-low emission technology, realizing the reuse of all wastes and the emission of no industrial residue, wastewater and waste throughout the process.`
            }
        },
        scienceAndTechnologyInnovate: {
            headlineTitle: "Technological Innovation",
            headlineP: "SCIENCE AND TECHNOLOGY INNOVATE",
            des: {
                text1: `DQ CARBON GROUP has established scientific research bases in Fushun, Harbin and many other places, strengthened the construction of scientific and technological personnel, and hired international and domestic scientific research and technical experts to focus on the development of high-purity graphite production and application of new technologies, new smelting processes, etc., in order to continuously promote the company's scientific and technological innovation.`,
                text2: `In terms of production and processing, the company's factories realize intelligent, automated, pipelined transportation and closed production from the entry of raw materials into the factory to the output of finished products. Employees do not participate in any equipment operations, and only need to conduct inspections throughout the process. Factory fire fighting also implements thermal induction automatic tracking fire extinguishing design to solve the problem of safety hazards from the perspective of equipment technology.`
            }
        },
        socialGood: {
            headlineTitle: "Social Welfare",
            headlineP: "SOCIAL GOOD",
            des: {
                title: "Donated 1 million yuan and materials to the Red Cross of Heilongjiang Province",
                text1: `In September 2022, the fight against the new crown epidemic entered a critical moment. DQ CARBON GROUP took the initiative to assume its corporate social responsibilities and donated 1 million to the Daqing Red Cross of Heilongjiang Province to support the prevention and control of the Daqing epidemic with practical actions. This donation is used to purchase necessary epidemic prevention materials and provide them to those in need to ensure their health and safety.`,
                text2: `In August 2023, Wuchang City, Heilongjiang Province, continued to suffer from heavy rainfall and severe flooding. After the disaster, the company donated flood relief funds to the Wuchang Red Cross as soon as possible to help the people of Wuchang overcome the floods and rebuild their homes.`
            },
            des2: {
                title: "Donated more than one million epidemic prevention materials to the embassies of Iran and other countries",
                text1: `Thousands of miles are the same, fate is the same! In July 2020, in view of the difficult period of epidemic prevention and control at home and abroad, DQ CARBON GROUP and its branches at home and abroad donated disinfectant, masks and other epidemic prevention materials to the embassies of Iran, other countries, and joined hands with friends from all over the world to work together to defeat the epidemic.`
            }

        }
    },
    talentDevelopment: {
        banner: {
            bannerTitle: "Talent Development",
            bannerP: "Talent Development",
        },
        growthAndDevelopment: {
            headlineTitle: "Growth And Development",
            headlineP: "GROWTH AND DEVELOPMENT",
            des: `<p>We uphold the employment mechanism of being able to go up and down, matching positions, knowing people and making good use of them, and employing talents, so as to give capable employees a stage to fully show themselves.</p>
            <p>“Do the same, like the same, become the same” is the characteristic of Daqing high-level newcomers.</p>
            <p>The interpersonal relationship here is simple, there is a fair promotion mechanism and broad space for development.</p>`,
            boxRow: {
                title: "Talents are the number one productive force, and DQ CARBON GROUP always insists on putting people first.",
                p: 'Safeguard the legitimate rights and interests of employees, and carry out professional training by creating a broad development platform for employees'
            },
            boxRow2: {
                title: "Care for the lives of employees and enhance their sense of belonging and value",
                p: 'Enhance the competitiveness of the industry, so as to achieve the goal of common growth of enterprises and employees'
            }
        },
        employeeCare: {
            headlineTitle: "Employee Care",
            headlineP: "EMPLOYEE CARE",
            des: 'The group attaches great importance to the cultivation of the comprehensive quality of employees and the development of professional skills, builds a learning team, enables employees to grow together with the enterprise, and strives to achieve the common development of the enterprise, society and employees.'
        },
        talentRecruitment: {
            headlineTitle: "Talent Recruitment",
            headlineP: "TALENT RECRUITMENT",
            des: 'In this ever-changing era, we know that talent is the most valuable asset of an enterprise, So we sincerely invite everyone who has dreams and has the courage to challenge you.',
            part1: 'Social recruitment ',
            part2: 'part-time recruitment',
            join: 'Join Us'
        },
    },
    talentRecruitment: {
        banner: {
            bannerTitle: "Talent Recruitment",
            bannerP: "Talent Recruitment",
        },
        tabs: {
            society: 'Social recruitment ',
            partTime: 'part-time recruitment',
            postName: 'Recruitment position',
            userNum: 'Number of people',
            workArea: 'Place of work',
            wages: 'Salary',
            createTime: 'Release time',
            btn: 'Submit resume',
            mainWork: 'Job Description',
            baseDemand: 'Posting Requirements'
        },
        updataForm: {
            title: 'Upload Resume',
            updataBtn: 'upload',
            type: 'format',
            submitBtn: 'Submit'
        }
    },
    supervisionAndReporting: {
        banner: {
            bannerTitle: "Supervision And Reporting",
            bannerP: "Supervision And Reporting",
        },
        introduce: `In order to strengthen the construction of clean government, eliminate illegal and disciplinary violations, maintain the integrity of the workforce, cultivate employees' noble professional ethics, ensure the integrity of employees in the performance of their duties, and deal with behaviors that harm the interests and image of the company and employees who damage the integrity of the performance of their duties due to corruption, accepting commercial bribes and malfeasance, the company encourages all employees, cooperative units and all walks of life to actively report fraud and other violations of discipline, and give high rewards to whistle-blowers, while strictly protecting whistle-blowers.`,
        reporting1: {
            headlineTitle: "Reporting Form",
            headlineP: "REPORTING FORM",
            title1: "1、Scope of report",
            title2: "2、Reporting channels",
            des1: `<p>The company encourages all persons with knowledge of the matter to report or provide effective evidence of the following fraudulent acts:</p> 
            <p>1.Employees accept bribes (such as gifts, gifts, rebates, handling fees, dry stocks, tourism, high-end entertainment activities, etc.) or other benefits (such as borrowing and borrowing, etc.), theft, embezzlement or misappropriation of company assets, fraud, disclosure of company secrets, abuse of power, improper related-party transactions, use of authority for personal gain and other fraudulent acts.</p>
            <p>2.Bribery, theft, embezzlement, fraud, infringement of trade secrets, etc. by suppliers or foreign units, violations of laws and regulations or violations of integrity agreements.</p>`,
            des2: `<p>Report phone: 17813617807</p><p>Report email: gh_wang@gaoxincarbon.com</p>
            <p>WeChat official account: DQ CARBON GROUP</p><p>Other ways: letter, visit or any other form</p>`
        },
        reporting2: {
            headlineTitle: "Reporting Rewards",
            headlineP: "REPORTING REWARDS",
            title1: `1、For reporting information or evidence provided, if the relevant information can be directly adopted by judicial organs and the case is characterized as a criminal case, rewards shall be given in accordance with the following standards:`,
            title2: `2、For those who report or provide true and directly usable information or evidence, and recover direct economic losses for the company (subject to the actual amount received by the company or the amount determined by the financial department), rewards shall be given in accordance with the following criteria:`,
            title3: `3、The above-mentioned rewards can be superimposed and used after being approved by the chairman of the board.`,
            title4: `4、 For cooperative units that report or provide direct and effective evidence, the above reward terms also apply.`,
            des1: `
            <p>1.For cases involving bribery of non-state staff, a reward of not less than 30,000 yuan shall be given;</p>
            <p>2.If it involves other types of criminal cases such as job encroachment, theft, and misappropriation of funds, a reward of not less than 10,000 yuan shall be given.</p>
            `,
            des2: `<p>1. If the economic loss is less than 100,000 yuan (including the principal amount), a reward of 1,000 yuan will be given;</p>
            <p>2.If the economic loss is recovered from 100,000 yuan to 500,000 yuan (including the principal amount), a reward of 1,000 yuan to 5,000 yuan will be given;</p>
            <p>3.If the economic loss is recovered from 500,000 yuan to 2 million yuan (including the principal amount), a reward of 5,000 yuan to 20,000 yuan will be given;</p>
            <p>4.If the economic loss is recovered from 2 million yuan to 8 million yuan (including the principal amount), a reward of 20,000 yuan to 80,000 yuan will be given;</p>
            <p>5.If the economic loss is more than 8 million yuan, a reward of 100,000 yuan will be given.</p>`,
            btn: 'Online Report'
        },
        dialogForm: {
            title: 'Supervision report',
            email: 'Report email',
            reporterType: 'Type of report',
            reporterItems: 'Matters to be reported',
            reportered: 'Subject of the report',
            reporteredTip: 'Name of the subject',
            deptName: 'Organization and Department',
            reporter: 'informer',
            reporterTip: 'Name of the informer',
            ifShow: 'Anonymously',
            reporterMobile: "Informer's contact information",
            file: 'Upload Reporting Materials',
            fileTip: 'Drag the file here, or',
            fileBtn: 'Click to upload',
            remark: 'Description of the issue',
            remarkTip: 'Please fill in the description of the issue',
            btn: 'Submit',
            reporterItemsTip: 'Please select at least one complaint',
            deptNameTip: 'Please fill in your unit and department',
            reporterMobileTip: 'Please fill in the contact information of the informant',
            uploadTip: 'Загрузка файла не должна превышать'
        }
    },
    contact: {
        banner: {
            bannerTitle: "Contact Us",
            bannerP: "Contact Us",
        },
        descLists: [{
                url: require("../../assets/img/contact/address.png"),
                title: 'Address',
                desc: '13/F, China Minmetals Building, No. 15, Anhuili Fourth District, Chaoyang District, Beijing, China'
            },
            {
                url: require("../../assets/img/contact/phone.png"),
                title: 'Tel:',
                desc: '+86 10-84831159  &nbsp; &nbsp;  Domestic Trade:  +86 10-84833454  &nbsp;&nbsp;  International Trade: +86 10-84832433 <br/> Business Cooperation: +86 17813617961 &nbsp;&nbsp; Executive Office: +86 17813617885'
            },
            {
                url: require("../../assets/img/contact/email.png"),
                title: 'Email:',
                desc: 'Gaoxin@gaoxincarbon.com'
            },
        ],
        wxName: 'WeChat official account',
        dyName: 'Tiktok official account',
        wdName: 'Micro shop'
    },
    year20: {
        // banner: {
        //     bannerTitle: "2020年",
        //     bannerP: "2020",
        // },
        vedio: {
            headling: "Grand Celebration of DQ CARBON GROUP's 20th Anniversary"
        },
        history: {
            headling: 'Development History'
        },
        news: {
            headling: 'News Report on the 20th Anniversary of DQ CARBON GROUP'
        },
        employee: {
            headling: 'DQ CARBON GROUP 20th Anniversary Meritorious Employees',
            des: "Ten years to sharpen a sword, 15 years to forge brilliance, 20 years to create a legend.  In the company's twenty years of development, there are a group of meritorious employees who have weathered the storm with the company.  With their youth and dreams, with dedication and dedication, they have jointly written a brilliant chapter in the history of the company.  Excellent employees from all over the country who have served for ten, fifteen and twenty years gathered together to accept the commendation of the group.  The organization also prepared a special gift for them - a solid gold medal of honor - to show appreciation for their outstanding contributions.  The meritorious employee representative took the stage and gave a moving speech, sharing every detail of their growth with the company.",
            title15: '15-Year Meritorious Employees',
            title10: '10-Year Meritorious Employees',
            title20: '20-Year Meritorious Employees'
        },
        bless: {
            headling: 'Warmest Congratulations to DQ CARBON Group'
        },
        activity: {
            headling: 'DQ CARBON GROUP 20th Anniversary Special Event'
        },
    }

}

export default en;